import axios from 'axios';
import { API_BASE_URL } from './scanApi';

// Le SteamID est stocké au scan (persiste entre les pages/rechargements).
export const getStoredSteamId = () => localStorage.getItem('kmg_steamid') || '';
export const storeSteamId = (id) => {
  if (id) localStorage.setItem('kmg_steamid', id);
};

export const getBillingStatus = (steamId) =>
  axios.get(`${API_BASE_URL}/billing/status`, { params: { steamId } });

export const startCheckout = ({ steamId, plan }) =>
  axios.post(`${API_BASE_URL}/billing/checkout`, { steamId, plan });

// Portail Stripe (gérer / annuler l'abonnement).
export const openPortal = (steamId) =>
  axios.post(`${API_BASE_URL}/billing/portal`, { steamId });
